import React, { Component } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperItem, FormWrapperInputComponent,
} from "../../../common/component/Index";
import DEFINE, { PATHS } from "../../../../../constants/Define";
import * as Func from '../../../../../helpers/functions';
import Wrapper from './../../../common/component/Wrapper';
import { get } from 'lodash';
import './RatingDetail.less';

let permisionActions = [];
const defaultState = {
    validation: {},
};

export default class RatingDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
        };
    }

    componentDidMount() {
        this.initDetail()
    }


    render() {
        const { t } = this.props;
        return (
            <Wrapper>Rating Detail</Wrapper>
        );
    }

    initDetail() {

    }

}

RatingDetail.defaultProps = {

};
